import queryString from 'query-string';
import { apiRequest, dataBaseUrl } from './apiRequest';

export const getQueryString = (startDate, endDate, other) => queryString.stringify({
  startDate: startDate ? new Date(startDate).toISOString().slice(0, 19).replace('T', ' ') : null,
  endDate: endDate ? new Date(endDate).toISOString().slice(0, 19).replace('T', ' ') : null,
  ...other,
});

export const getAllSales = async (startDate, endDate) => {
  let url = `/reports/sales?${getQueryString(startDate, endDate)}`;
  try {
    let response = await apiRequest(dataBaseUrl, url, {
      method: 'get',
      withAuth: true
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllSalesPredefined = async (rangeType) => {
  let url = `/reports/company/predefined?${queryString.stringify({ rangeType })}`;
  try {
    let response = await apiRequest(dataBaseUrl, url, {
      method: 'get',
      withAuth: true
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAggregateSales = async (startDate, endDate) => {
  let url = `/reports/sales/aggregate?${getQueryString(startDate, endDate)}`;
  try {
    let response = await apiRequest(dataBaseUrl, url, {
      method: 'get',
      withAuth: true
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllUserSalesPredefined = async (rangeType) => {
  let url = `/reports/user/predefined?${queryString.stringify({ rangeType })}`;
  try {
    let response = await apiRequest(dataBaseUrl, url, {
      method: 'get',
      withAuth: true
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const getAggregateSalesByUser = async (startDate, endDate) => {
  let url = `/reports/sales/aggregateuser?${getQueryString(startDate, endDate)}`;
  try {
    let response = await apiRequest(dataBaseUrl, url, {
      method: 'get',
      withAuth: true
    });
    return response;
  } catch (error) {
    throw error;
  }
};


/* Account Endpoints */
export const getAllAccountSalesPredefined = async (rangeType) => {
  let url = `/reports/account/predefined?${queryString.stringify({ rangeType })}`;
  try {
    let response = await apiRequest(dataBaseUrl, url, {
      method: 'get',
      withAuth: true
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const getAggregateSalesByAccount = async (startDate, endDate) => {
  let url = `/reports/sales/aggregateaccount?${getQueryString(startDate, endDate)}`;
  try {
    let response = await apiRequest(dataBaseUrl, url, {
      method: 'get',
      withAuth: true
    });
    return response;
  } catch (error) {
    throw error;
  }
};


export const getHSAMetrics = async (limit) => {
  let url = `/reports/sales/hsacompanies?${queryString.stringify({ limit: limit })}`;
  try {
    let response = await apiRequest(dataBaseUrl, url, {
      method: 'get',
      withAuth: true
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getHSAOfferings = async () => {
  let url = '/reports/sales/ltdhsaofferings';
  try {
    let response = await apiRequest(dataBaseUrl, url, {
      method: 'get',
      withAuth: true
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAvgHSAOfferings = async () => {
  let url = '/reports/sales/ltdhsaofferingsavg';
  try {
    let response = await apiRequest(dataBaseUrl, url, {
      method: 'get',
      withAuth: true
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getRecentSale = async (ids) => {
  let url = `/reports/sales/recentsale?${queryString.stringify({ ids: [ids] })}`;
  console.log(url);
  try {
    let response = await apiRequest(dataBaseUrl, url, {
      method: 'get',
      withAuth: true
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTargetUserSalePredefined = async (userEmail, range) => {
  let url = `/reports/sales/targetuserpre?${queryString.stringify({userEmail, range})}`;
  try {
    let response = await apiRequest(dataBaseUrl, url, {
      method: 'get',
      withAuth: true
    });
    return response;
  } catch (error) {
    throw error;
  }
};